import React from "react"
import {Button} from "scholastic-client-components/src/ui/Button/Button"
import {Trans, useTranslation} from "react-i18next"

interface VerificationWarningProps {
    resendConfirmEmail: () => void
    timeLeft: number
    loader: boolean
}

export const VerificationWarning: React.FC<VerificationWarningProps> = ({
    resendConfirmEmail,
    timeLeft,
    loader,
}) => {
    const {t} = useTranslation(["auth_portal"])

    return (
        <div data-cy={"verification-warning"}>
            <Trans
                i18nKey={"auth_portal:email_not_verified"}
                components={{
                    lbr: <br />,
                }}
            />
            <Button
                data-cy="resend-confirmation"
                onClick={resendConfirmEmail}
                disabled={!!timeLeft}
                loader={loader}
                text
            >
                {t("auth_portal:resend_email_button", {count: timeLeft})}
            </Button>
        </div>
    )
}
